import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Table, Row, Button, Drawer, Divider, Input, message, Popconfirm, Descriptions, Spin } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import { NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, showErrorInNotification, formatMoney } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton, CustomButton, IconButton } from '../../../components/basic_items';
import { PauseCircleFilled, PlayCircleFilled, Done, Delete, Close } from '@material-ui/icons';
import { COLORS } from '../../theme';


const queryString = require('query-string');

const request_list = ({ props, onAccept, onReject, onDelete }) => [
  {
    title: "Created at",
    dataIndex: 'created_at',
    key: 'created_at'
  },
  {
    title: "Action",
    dataIndex: 'action',
    key: 'action'
  },
  {
    title: "Maker",
    dataIndex: 'maker_name',
    key: 'maker_name',
  },
  {
    title: "Checker",
    dataIndex: 'checker_name',
    key: 'checker_name'
  },
  {
    title: "Status",
    dataIndex: 'status',
    key: 'status'
  },


  {
    title: "Action",
    dataIndex: 'id',
    key: 'actions',
    align: 'center',
    width: 200,
    render: (id, data) => {

      let is_deletable = data.delete;
      let is_acceptable = data.approve;
      let is_rejectable = data.reject;

      return <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }}>
        <Popconfirm
          title="Are you sure you want to accept this request?"
          disabled={!is_acceptable}
          onConfirm={() => {
            if (is_acceptable) {
              typeof onAccept === 'function' && onAccept(id)
            }
          }}>
          <IconButton
            title="Accept this request"
            icon={<Done style={{
              color: is_acceptable ? COLORS.success_primary : COLORS.secondary
            }} />}
            className={is_acceptable ? '' : 'no-cursor'}
          // label="DISABLE"
          />
        </Popconfirm>
        <Divider type='vertical' />
        <Popconfirm
          disabled={!is_rejectable}
          title="Are you sure you want to reject this request?"
          onConfirm={() => {
            if (is_rejectable) {
              typeof onReject === 'function' && onReject(id)
            }
          }}>
          <IconButton
            title="Reject this request"
            icon={<Close style={{
              color: is_rejectable ? COLORS.warning_primary : COLORS.secondary
            }} />}

            className={is_rejectable ? '' : 'no-cursor'}
          // label="DISABLE"
          />
        </Popconfirm>
        <Divider type='vertical' />
        <Popconfirm
          disabled={!is_deletable}
          title="Are you sure you want to delete this request?"
          onConfirm={() => {
            if (is_deletable) {
              // 
              typeof onDelete === 'function' && onDelete(id)
            }
          }}>
          <IconButton
            title="Delete this request"
            icon={<Delete style={{
              color: is_deletable ? COLORS.danger_primary : COLORS.secondary
            }} />}

            className={is_deletable ? '' : 'no-cursor'}
          // label="DISABLE"
          />
        </Popconfirm>
      </div>
    }
  }
]
class MakerCheckerList extends Component {

  constructor(props) {
    super(props)

    this.state = {
      add_edit_status: null,
      edit_config_id: null,
      filter_query: {}
    };

    this.list_makercheckers = RESTExecutor.list().config({
      label: 'list',
    }).connect(props.domains.makerchecker);

    // this.list_makercheckers.execute();

    this.accept_me = RESTExecutor.post().config({
      label: 'accept',
    }).callbacks((success) => {
      message.success("Request Accepted");
      this.list_makercheckers.execute()
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.makerchecker);

    this.reject_me = RESTExecutor.post().config({
      label: 'reject',
    }).callbacks((success) => {
      message.success("Request Rejected");
      this.list_makercheckers.execute()
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.makerchecker);

    this.delete_me = RESTExecutor.post().config({
      label: 'delete',
    }).callbacks((success) => {
      message.success("Request Deleted");
      this.list_makercheckers.execute()
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.makerchecker);


    this.delay_search = new NetworkDelaySearch();


  };

  stateUpdater = ({
    stateKey,
    valueKey,
    value,
    appendObj = {},
    callback
  }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }

  render() {
    let list_makercheckers_resp = this.list_makercheckers.response();
    let list_makercheckers_data = list_makercheckers_resp.result || {};

    let rowsData = list_makercheckers_data.rows || [];
    let rowsMeta = list_makercheckers_resp.meta || {};
    const { filter_query } = this.state;

    return (
      <div>
        <BasicHeader no_back title="Maker Checker Requests"
          menu_items={setting_quick_menu}
        // right={[
        //     <TransparentButton
        //         label="Add New"
        //         className='cta-primary'
        //         hint="Add New Cron"
        //         onClick={() => {
        //             this.setState({
        //                 add_edit_status: 'add'
        //             })
        //         }}

        //     />,
        // ]}

        />
        <div className='filter-card'>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
            paddingTop: 4, paddingBottom: 12
          }}>
            <Input.Search
              placeholder="Search For"
              style={{
              }}
              autoFocus
              value={filter_query.query}
              onChange={(e) => {
                this.stateUpdater({
                  stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                    this.delay_search.onSearch(() => {
                      this.props.history.push({
                        // pathname:"users",
                        search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                      })
                    })

                  }
                })
              }} />
          </div>
        </div>
        <ErrorWrapper
          error={list_makercheckers_resp}
          onReload={() => {
            this.list_makercheckers.execute()
          }}
        >


          <div className='default-card' style={{ padding: 0 }}>
            <Table
              className='main-table'
              loading={list_makercheckers_resp.fetching}
              size='small'

              scroll={{ x: true }}
              pagination={{
                simple: false,
                position: 'bottom',
                onChange: (current, size) => {
                  this.props.history.push({
                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                  })
                },
                defaultCurrent: 1,
                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                // defaultPageSize: 20,
                pageSize: (rowsMeta && rowsMeta.requested_count),

                total: (rowsMeta && rowsMeta.total_count),
                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
              }}
              // bordered={false}
              rowKey={(record) => `-${record.id}-`}
              expandedRowRender={(record, index, indent, expanded) => {
                if (expanded) {
                  return <MakerCheckerDetail id={record.id} key={`//${record.id}`} />
                }
              }}
              columns={request_list({
                onAccept: (id) => {
                  this.accept_me.forId(id).execute()
                },
                onDelete: (id) => {
                  this.delete_me.forId(id).execute()
                },
                onReject: (id) => {
                  this.reject_me.forId(id).execute()
                }
              })}
              dataSource={rowsData}
            />


          </div>
        </ErrorWrapper>
      </div>
    )
  }

  componentDidMount() {
    overrideHeaderTitle("Cron Configs");
    overrideHeaderBack(null);
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query
      }
    }, () => {
      this.list_makercheckers.config({
        params: {
          ...this.state.filter_query
        }
      }).execute()
    })



  }
  componentWillReceiveProps(nextProps) {

    let new_filter_query = {};
    if ((this.props.location.search !== nextProps.location.search)) {
      const parsed = queryString.parse(nextProps.location.search);
      new_filter_query = parsed;
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...new_filter_query
        }
      }, () => {
        this.list_makercheckers.config({
          params: {
            ...this.state.filter_query
          }
        }).execute()
      })
    } else {
      //   this.list_logs.execute()
    }


  }
}


export default withDomains(MakerCheckerList, "makerchecker");


class _MakerCheckerDetail extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: {},
      loading: true
    }

    this.get_detail=RESTExecutor.detail().config({
      label:'params'
    }).forId(this.props.id).callbacks((success)=>{
      console.log("succ",success)
      this.setState({
        data:success.result||[],
        loading:false
      })
    },(error)=>{
      showErrorInNotification(error);
      this.setState({
        loading:false
      })
    }).connect(props.domains.makerchecker);

    this.get_detail.execute();
  }

  render() {
    const {data,loading}=this.state;
    let params=data.params||[];

    return <Spin spinning={loading}><div>
        {params.length>0?<Descriptions>
          {params.map((item,index)=>{
            return <Descriptions.Item key={index} label={item.key}>{typeof item.value === 'string' ? item.value : JSON.stringify(item.value)}</Descriptions.Item>
          })}
        </Descriptions>
        :!loading?<span style={{
          opacity:0.5
        }}>No any params</span>:null
        }
    </div>
    </Spin> 
  }
}
const MakerCheckerDetail=withDomains(_MakerCheckerDetail,"makerchecker");